// extracted by mini-css-extract-plugin
export var accent = "_2x-4";
export var add = "_2x-j";
export var addIcon = "_2x-k";
export var deleteIcon = "_2x-i";
export var disabled = "_2x-9";
export var ellipsis = "_2x-f";
export var error = "_2x-3";
export var form = "_2x-5";
export var hideFocus = "_2x-2";
export var icon = "_2x-7";
export var input = "_2x-e";
export var listItem = "_2x-h";
export var mediumHeight = "_2x-b";
export var noBorder = "_2x-8";
export var noRadius = "_2x-1";
export var shortHeight = "_2x-a";
export var tallHeight = "_2x-c";
export var textInput = "_2x-0";
export var vertical = "_2x-g";
export var veryTallHeight = "_2x-d";
export var widget = "_2x-6";